import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateBranch({ username, onBranchID, onClose, getBranchs }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    let user2;
    try {
        user2 = JSON.parse(username);
    } catch (e) {
        user2 = username;
    }

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        comment: '',
        user_transaction: user2,
        est_id: '',
        id: ''
    });

    useEffect(() => {
        const getBranchs = async () => {
            try {
                const response = await axios.get(`${server_backend}/branchs/select?id=${onBranchID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];

                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        phone: data.phone,
                        address: data.address,
                        city: data.city,
                        country: data.country,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID,
                        id: onBranchID
                    });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getBranchs();
    }, [onBranchID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        //setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/branchs/update`, formData, headers);

                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        onClose()
                        getBranchs()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'There is already a branch with the same name, please try with another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
        })
    };

    return (

        <div className="row">
            <div>
                <div className="card">
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12">
                            <div className="text-end">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>

                                <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                    {loading ? "Loading..." : "Update"}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="tab-pane fade show active" id="pills-bill-info" role="tabpanel" aria-labelledby="pills-bill-info-tab">
                            <div className="live-preview">
                                <form onSubmit={handleUpdate}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="name" className="form-label">ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    id="name"
                                                    name="name"
                                                    value={onBranchID}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="name" className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    id="name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="address" className="form-label">Address</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter address"
                                                    id="address"
                                                    name="address"
                                                    value={formData.address}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="city" className="form-label">City</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your city"
                                                    id="city"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="country" className="form-label">Country</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your country"
                                                    id="country"
                                                    name="country"
                                                    value={formData.country}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="phone" className="form-label">Phone</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    placeholder="Enter phone number"
                                                    id="phone"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Status</label>
                                                <select
                                                    className="form-select"
                                                    aria-label=".form-select-sm example"
                                                    name="est_id"
                                                    value={formData.est_id}
                                                    onChange={handleChange}
                                                >
                                                    {formData.est_id === 1 ? (
                                                        <>
                                                            <option value="1">Activated</option>
                                                            <option value="2">Disabled</option>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <option value="2">Disabled</option>
                                                            <option value="1">Activated</option>
                                                        </>
                                                    )}

                                                </select>

                                            </div>
                                            <br />
                                        </div>

                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="comment" className="form-label">Comment</label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter comment"
                                                    id="comment"
                                                    name="comment"
                                                    value={formData.comment}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>

                                        <h4 className='p-4'>Other Information</h4>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="user_transaction"
                                                    value={vAdminformat.FormatDate(dateCreated)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userCreated}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userModify}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="card-header align-items-center d-flex">
                                            <div className="col-md-12">
                                                <div className="text-end">
                                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>

                                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                                        {loading ? 'Loading...' : 'Update'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default UpdateBranch;
